import React, { useState } from 'react'; 
import { useNavigate } from 'react-router-dom'; 
import './Homepage.css';
import Header from '../Header/header';
import Footer from '../Footer/footer';
import { Carousel } from 'react-bootstrap';
import Icon1 from '../../Assets/contract1.svg'; 
import Icon2 from '../../Assets/Permanent1.svg';
import Icon3 from '../../Assets/temporary1.svg';
import Icon4 from '../../Assets/temporary1.svg';
import Icon5 from '../../Assets/temporary1.svg';
import Icon6 from '../../Assets/temporary1.svg';
import Icon7 from '../../Assets/temporary1.svg';
import Icon8 from '../../Assets/temporary1.svg';
import AboutImg from '../../Assets/model3.jpg'
import Car1 from '../../Assets/car1.png'
import Car2 from '../../Assets/car2.png'
import Car3 from '../../Assets/car3.png'



const categories = { "IT": ["Software Development", "Network Administration", "Cybersecurity",".NET","Python","Pharma","IT Support","Data Science","DevOps","Cloud Computing","Mobile App Development"],
   "Non IT": ["Marketing", "Sales", "Human Resources","BPO","KPO","Salesforce"],
   "Manufacturing": []
   };

const Homepage = () => {


  const handleLearnMoreClick = () => {
    navigate('/about'); // Redirect to the About Us page
  };

  const navigate = useNavigate();
  
  const [selectedCategory, setSelectedCategory] = useState(""); 
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState("");

   const handleCategoryChange = (event) => { 
    const category = event.target.value;
    setSelectedCategory(category); 
    setSubcategories(categories[category] || []); 
    setSelectedSubcategory(""); // Reset subcategory when category changes
  };


  const handleSubcategoryChange = (event) => {
    setSelectedSubcategory(event.target.value);
  };


  const handleSearchClick = () => {
    // Redirect to the job openings page with selected options as query parameters
    navigate(`/jobs?category=${selectedCategory}&subcategory=${selectedSubcategory}`);
  };


  const trendingKeywords = [
    "Project Management",
    "Accounts & finance",
    "Production & quality",
    "Design, R & D",
    "HRBP & IR",
    "Railway & metro",
    "Transmission line & substation",
    "Sales & Marketing",
    "Green field and brown field Projects",
    "Billing, purchase & tendering",
    "EPC and infrastructure projects",
  ];


    return (

      <> <div className="homepage">
      {/* Header Section */}
              <Header/>
      
      {/* Hero Section */}
      
      
      <section className="hero">
      
          <Carousel>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={Car1}
                alt="First slide"
              />
              <Carousel.Caption>
               
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={Car2}
                alt="Second slide"
              />
              <Carousel.Caption>
                
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={Car3}
                alt="Third slide"
              />
              <Carousel.Caption>
                
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        
        
      </section>
      
      {/* About Section */}
      <div className="about-section">
            <div className="about-image">
              <img src={AboutImg} alt="About Us" />
            </div>
            <div className="about-content">
              <h2>About Us</h2>
              <p>
              We are young and dynamic job Placement Company. Premiere India- based Organisation specializing in the provision of human capital resource solutions. We offer services 	in 	temporary 	and 	contract recruitment, outsourcing, permanent recruitment and bulk manpower recruitment across India. 
       
       Shritech understands what it takes for a company to hire the right professional for the right position and we have developed comprehensive and continuously growing database of highly qualified candidates in a variety of industries.
       
              </p>
              <button className="about-button" onClick={handleLearnMoreClick}>Learn More</button>
            </div>
          </div>
      
      {/* Staffing Services Section */}
      <div className="staffing-section" id="staffing">
            <div className="image-section">
              <div className="overlay">
                <h1>Empowering you with Trusted Manpower and Technology</h1>
                <p>Building Careers and Building Organizations</p>
              </div>
            </div>
            <div className="cards-section">
              <div className="card">
                <div className="icon">
                <img src={Icon1} alt="Icon 1" />
                </div>
                <h3>Contract Based Staffing</h3>
                <p>Is your organization looking at increasing the headcount in short span of time without increasing your fixed cost?</p>
              </div>
              <div className="card">
                <div className="icon">
                <img src={Icon2} alt="Icon 2" />
                </div>
                <h3>Permanent Staffing</h3>
                <p>At Shritech, we believe in transparent, and ethical approach to screening, interviewing, and appointing an employee.</p>
              </div>
              <div className="card">
                <div className="icon">
                <img src={Icon3} alt="Icon 3" />
                </div>
                <h3>Temporary Staffing</h3>
                <p>Custom application development is a process oriented activity in Shritech Technologies Softwares offshore facility. All software is developed in our facility using the Software Factory approach.</p>
              </div>
            </div>
          </div>
      
      
      {/* Job Openings Section */}
      
      
      <div className="job-browsing-section" id="job-browsing-section">
            <div className="image-overlay">
              <h1>3000+ Browse Jobs</h1>
              <p>Find Jobs, Employment & Career Opportunities</p>
              <div className="button-section">
              <select className="category-dropdown" value={selectedCategory} onChange={handleCategoryChange} > 
                <option value="">Select Category</option>
                 <option value="IT">IT</option>
                  <option value="Non IT">Non IT</option> 
                  <option value="Manufacturing">Manufacturing</option>
                  </select> 
                  <select
                    className="subcategory-dropdown"
                    value={selectedSubcategory}
                    onChange={handleSubcategoryChange}
                    disabled={!selectedCategory}
                  >
                    <option>Select Subcategory</option> {subcategories.map((subcategory, index) => (
                       <option key={index} value={subcategory}> {subcategory}
                       </option> ))}
               </select>
                <button className="search-button" onClick={handleSearchClick}>Search</button>
              </div>
              <p className="trending-keywords-title">Trending Keywords</p>
                          <div className="trending-keywords">
                      {trendingKeywords.map((keyword, index) => (
                        <span key={index} className="keyword-badge">
                          {keyword}
                        </span>
                      ))}
                    </div>
            </div>
            <div className="feature-text">Browse some featured categories</div>
            <div className="mini-cards">
              <div className="mini-card">
                <img src={Icon4} alt="Icon 1" />
                <p>Engineering & Construction </p>
              </div>
              <div className="mini-card">
                <img src={Icon5} alt="Icon 2" />
                <p>Manufacturing </p>
              </div>
              <div className="mini-card">
                <img src={Icon6} alt="Icon 3" />
                <p>Retail </p>
              </div>
              <div className="mini-card">
                <img src={Icon7} alt="Icon 4" />
                <p>Manufacturing & Other</p>
              </div>
              <div className="mini-card">
                <img src={Icon8} alt="Icon 5" />
                <p>IT & Service Sector</p>
              </div>
            </div>
          </div>
      
      
      
      {/* Footer Section */}
      <Footer/>
      
      
      </div>  </>



    );
};

export default Homepage;
